<template>
  <v-container fluid class="statistics-container">
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="primary" size="64" />
    </div>
    <div v-else-if="dashboardUrl" class="statistics-iframe-wrapper">
      <iframe class="statistics-iframe" :src="dashboardUrl" width="100%" frameborder="0" allowfullscreen></iframe>
    </div>
    <div v-else class="text-center text--disabled">
      {{ $t("Dashboard not found") }}
    </div>
  </v-container>
</template>

<script>
export default {
  name: "StatisticsPage",
  data() {
    return {
      loading: true,
      dashboardUrl: null,
    };
  },
  computed: {
    doctorId() {
      return this.$store.state.auth.id;
    },
    dashboards() {
      return this.$store.state.auth.dashboards || [];
    },
  },
  methods: {
    async loadDashboard() {
      const dashboardId = this.$route.params.id;

      let existing = this.dashboards.find(d => d.id == dashboardId);

      if (!existing) {
        try {
          const { data } = await this.$http.get(`/v1/users/${this.doctorId}/dashboards`);
          const dashboards = data.dashboards || [];
          this.$store.commit("auth/SET_DASHBOARDS", dashboards);
          existing = dashboards.find(d => d.id == dashboardId);
        } catch (e) {
          console.error("Failed to load dashboards", e);
        }
      }

      if (existing) {
        const url = existing.url;
        try {
          const { data } = await this.$http.post("/v1/grafana/jwt");
          const grafanaToken = data.token || data.data?.token;
          if (grafanaToken) {
            const separator = url.includes("?") ? "&" : "?";
            this.dashboardUrl = `${url}${separator}auth_token=${encodeURIComponent(grafanaToken)}`;
          } else {
            this.dashboardUrl = url;
          }
        } catch (e) {
          console.error("Failed to get Grafana JWT:", e);
          this.dashboardUrl = url;
        }
      }
      this.loading = false;
    },
  },
  watch: {
    "$route.params.id"() {
      this.loading = true;
      this.dashboardUrl = null;
      this.loadDashboard();
    },
  },
  async created() {
    await this.$store.dispatch("auth/loadProfile");
    this.loadDashboard();
  },
};
</script>

<style scoped>
.statistics-container {
  padding: 0;
  height: calc(100vh - 64px);
}

.statistics-iframe-wrapper {
  width: 100%;
  height: calc(100vh - 64px);
}

.statistics-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
